import React from 'react';
import cn from '@/utils/cn';

export const FieldGroup = ({
  className,
  ...props
}: React.ComponentPropsWithoutRef<'div'>) => {
  return (
    <div
      data-slot="control"
      {...props}
      className={cn(className, 'space-y-8')}
    />
  );
};
